import { domainFactory } from '@/core/lib/Domain';
import routes from '@/domains/clients/routes';

const ClientsDomain = domainFactory(routes);

export default ClientsDomain;
